import { Modal } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import { KTIcon, toAbsoluteUrl } from '../../../_metronic/helpers';
import { Fancybox as NativeFancybox } from '@fancyapps/ui'
import { useEffect, useMemo, useRef, useState } from 'react';
import { fetchData, getEncryptedRoute, toasterrormsg, toastsuccessmsg, useMenuIdPermissions } from '../../../reusable';
import moment from 'moment';
import { isEmptyArray } from 'formik';
import Skeleton from 'react-loading-skeleton'
import LikesModal from './LikesModal';
import { createPortal } from 'react-dom';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import { CommentsItem, PostMedia, PostModalProps } from '../types/explore';
import clsx from 'clsx';


export default function PostModal({
    show,
    onHide,
    selectedPost,
    profileDetails,
    url = '',
    t = (key) => key,
    allPosts = [],
    currentIndex = 0,
    onNavigate,
    // 
    commentsCache,
    setCommentsCache,
    commentsTotalRecordCache,
    setCommentsTotalRecordCache
}: PostModalProps) {



    const { menuId } = useMenuIdPermissions()

    const [showOptionsModal, setShowOptionsModal] = useState(false);
    const [showReportModal, setShowReportModal] = useState(false);
    const [showLikesModal, setShowLikesModal] = useState(false);
    const [modalType, setModalType] = useState<'post' | 'comment' | "">('')
    const [selectedCommentId, setSelectedCommentId] = useState(0);
    const [comments, setComments] = useState<CommentsItem[]>([])
    const [totalRecord, setTotalRecord] = useState(0)
    const scrollContainerRef = useRef<HTMLDivElement>(null)
    const [isTransitioning, setIsTransitioning] = useState(false)
    const [transitionDirection, setTransitionDirection] = useState<'left' | 'right' | null>(null)
    const [showReportDetailsModal, setShowReportDetailsModal] = useState(false);
    const lastLoadedPostIdRef = useRef<number | string | null>(null);


    const [selectedReportType, setSelectedReportType] = useState<'false_information' | 'spam' | 'other' | ''>('');
    const [reportTitle, setReportTitle] = useState('');
    const [reportDescription, setReportDescription] = useState('');
    const [admindata, setadminData] = useState<any>(null)


    const [isLoading, setIsLoading] = useState(false)
    const [isLoadingMore, setIsLoadingMore] = useState(false)
    const [limit] = useState(10)
    const [offset, setOffset] = useState(0)
    const [sortBy] = useState('created')
    const [sort] = useState('desc')
    const shouldHidePostControls = showOptionsModal || showLikesModal || showReportModal || showReportDetailsModal;

    const hasPrevious = currentIndex > 0
    const hasNext = currentIndex < allPosts.length - 1

    const hasMore = comments.length < totalRecord

    // Navigation handlers
    const handlePrevious = async () => {
        if (hasPrevious && !isTransitioning && onNavigate) {
            setIsTransitioning(true)
            setTransitionDirection('right')

            setTimeout(() => {
                onNavigate(currentIndex - 1)
                setOffset(0)
                setComments([])

                setTimeout(() => {
                    setIsTransitioning(false)
                    setTransitionDirection(null)
                }, 50)
            }, 300)
        }
    }

    const handleNext = async () => {
        if (hasNext && !isTransitioning && onNavigate) {
            setIsTransitioning(true)
            setTransitionDirection('left')

            setTimeout(() => {
                onNavigate(currentIndex + 1)
                setOffset(0)
                setComments([])

                setTimeout(() => {
                    setIsTransitioning(false)
                    setTransitionDirection(null)
                }, 50)
            }, 300)
        }
    }

    const deletePost = (postId: any) => {
        Swal.fire({
            title: 'Are you sure?',
            html: `
            <p>Are you sure you want to delete this post?</p>
            <small style="color:#6c757d">
                Once deleted, this post will be permanently removed and will not be visible anywhere.
            </small>
            `,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    setIsLoading(true)
                    const param = {
                        postId: postId,
                                                adminId: admindata?.adminId,

                    }
                    const response = await fetchData('admin/explore/post/delete', param, "DELETE")

                    if (response.status == '200') {
                        toastsuccessmsg(response.message || 'Deleted Successfully')
                        onHide()
                        setShowOptionsModal(false)
                    } else {
                        toasterrormsg(response.message)
                    }
                } catch (error) {
                    console.error('Error deleting post:', error)
                    toasterrormsg('Failed to delete post')
                } finally {
                    setIsLoading(false)
                }
            }
        })
    }

    // Keyboard navigation
    useEffect(() => {
        if (showLikesModal || showOptionsModal || showReportModal || showReportDetailsModal) return
        const handleKeyPress = (e: KeyboardEvent) => {
            if (!show) return

            if (e.key === 'ArrowLeft') {
                handlePrevious()
            } else if (e.key === 'ArrowRight') {
                handleNext()
            } else if (e.key === 'Escape') {
                onHide()
            }
        }

        window.addEventListener('keydown', handleKeyPress)
        return () => window.removeEventListener('keydown', handleKeyPress)
    }, [show, currentIndex, hasPrevious, hasNext, isTransitioning, showLikesModal, showOptionsModal, showReportModal, showReportDetailsModal])

    // Touch swipe support
    useEffect(() => {
        if (!show) return

        let touchStartX = 0
        let touchEndX = 0
        const minSwipeDistance = 50

        const handleTouchStart = (e: TouchEvent) => {
            touchStartX = e.changedTouches[0].screenX
        }

        const handleTouchEnd = (e: TouchEvent) => {
            touchEndX = e.changedTouches[0].screenX
            const swipeDistance = touchStartX - touchEndX

            if (Math.abs(swipeDistance) > minSwipeDistance) {
                if (swipeDistance > 0) {
                    // Swiped left - next post
                    handleNext()
                } else {
                    // Swiped right - previous post
                    handlePrevious()
                }
            }
        }

        const modalContent = document.querySelector('.post-modal-content')
        if (modalContent) {
            modalContent.addEventListener('touchstart', handleTouchStart as any)
            modalContent.addEventListener('touchend', handleTouchEnd as any)
        }

        return () => {
            if (modalContent) {
                modalContent.removeEventListener('touchstart', handleTouchStart as any)
                modalContent.removeEventListener('touchend', handleTouchEnd as any)
            }
        }
    }, [show, currentIndex, hasPrevious, hasNext, isTransitioning])


    // comment list api call
    const postCommentsListApiCall = async (currentOffset: number, isLoadMore = false,) => {
        const postId = selectedPost?.postId;
        if (!postId) return;

        // Check cache first for initial load
        if (!isLoadMore && commentsCache[postId]) {
            setComments(commentsCache[postId]);
            setTotalRecord(commentsTotalRecordCache[postId] || 0);
            setIsLoading(false);
            return;
        }


        if (isLoadMore) {
            setIsLoadingMore(true);
        } else {
            setIsLoading(true);
        }
        const param = {
            postId: selectedPost?.postId,
            limit: limit,
            offset: currentOffset,
            sort: sort,
            sortBy: sortBy
        }
        try {
            const response = await fetchData("admin/explore/post/comment/list", param, 'POST')

            if (response.status == '200') {
                const data = response.data
                if (isLoadMore) {
                    const updatedComments = [...comments, ...data.list];
                    setComments(updatedComments);
                    // Update cache with new comments
                    setCommentsCache(prev => ({
                        ...prev,
                        [postId]: updatedComments
                    }));

                } else {
                    setComments(data.list);
                    // Cache initial comments
                    setCommentsCache(prev => ({
                        ...prev,
                        [postId]: data.list
                    }));
                }

                // Set total record from API response
                setTotalRecord(data.totalRecord || 0)
                setCommentsTotalRecordCache(prev => ({
                    ...prev,
                    [postId]: data.totalRecord || 0
                }));
            } else {
                toasterrormsg(response.message)
                setComments([])
                setTotalRecord(0)
            }
        } catch (error) {
            console.error('Error fetching comments:', error)
            // toasterrormsg('Failed to load comments')
            setComments([])
            setTotalRecord(0)
        } finally {
            if (isLoadMore) {
                setIsLoadingMore(false)
            } else {
                setIsLoading(false)
            }

        }
    }

    // report post
    const submitReport = async () => {
        // Validation
        if (!selectedReportType) {
            toasterrormsg(t('Please select a report reason'));
            return;
        }

        if (!reportDescription.trim()) {
            toasterrormsg(t('Please provide a description'));
            return;
        }

        if (selectedReportType === 'other' && !reportTitle.trim()) {
            toasterrormsg(t('Please provide a title'));
            return;
        }

        try {
            setIsLoading(true);
            const param = {
                postId: selectedPost?.postId,
                violation: reportTitle || selectedReportType,
                reason: reportDescription,
                adminId: admindata.adminId,

            };
            const response = await fetchData('admin/explore/post/report', param, 'POST');

            if (String(response?.status) === '200') {
                toastsuccessmsg(response.message || t('Report submitted successfully'));
                // Reset and close
                setShowReportModal(false);
                setShowOptionsModal(false);
                setSelectedReportType('');
                setReportTitle('');
                setReportDescription('');
            } else {
                toasterrormsg(response?.message || t('Failed to submit report'));
            }
        } catch (error) {
            console.error('Error submitting report:', error);
            // toasterrormsg(t(response.message));
        } finally {
            setIsLoading(false);
        }
    };


    const handleScroll = () => {
        if (!scrollContainerRef.current) return
        const { scrollTop, scrollHeight, clientHeight } = scrollContainerRef.current
        // Trigger load more when user scrolls near bottom

        if (scrollTop + clientHeight >= scrollHeight - 50) {
            if (hasMore && !isLoadingMore && !isLoading) {
                const newOffset = offset + limit
                setOffset(newOffset)
                postCommentsListApiCall(newOffset, true)
            }
        }
    }


    useEffect(() => {
        if (!selectedPost?.postId) return;

        // Prevent duplicate calls for same post
        if (lastLoadedPostIdRef.current === selectedPost.postId) {
            // If we have cached data, use it
            if (commentsCache[selectedPost.postId]) {
                setComments(commentsCache[selectedPost.postId]);
                setTotalRecord(commentsTotalRecordCache[selectedPost.postId] || 0);
            }
            return;
        }

        lastLoadedPostIdRef.current = selectedPost.postId;

        // Reset pagination
        setOffset(0);

        // Load from cache or fetch
        if (commentsCache[selectedPost.postId]) {
            setComments(commentsCache[selectedPost.postId]);
            setTotalRecord(commentsTotalRecordCache[selectedPost.postId] || 0);
        } else {
            setComments([]);
            setTotalRecord(0);
            postCommentsListApiCall(0, false);
        }
    }, [selectedPost?.postId]);


    useEffect(() => {
        const tmp: any = sessionStorage.getItem('admin')
        if (tmp) {
            setadminData(JSON.parse(tmp))
        }

        NativeFancybox.bind('[data-fancybox="gallery"]', {});
        return () => {
            NativeFancybox.destroy();
        };

    }, []);

    const swiperConfig = useMemo(() => ({
        modules: [Navigation, Pagination],
        navigation: {
            prevEl: '.swiper-btn-prev-custom',
            nextEl: '.swiper-btn-next-custom',
        },
        pagination: {
            clickable: true,
            el: '.swiper-pagination-custom'
        },
        spaceBetween: 0,
        slidesPerView: 1,
        lazy: false, 
        speed: 300,
        preloadImages: true, 
        watchSlidesProgress: false, 
        observer: true, 
        observeParents: true, 
    }), []);


    if (!selectedPost) return null;


    const CommentItem = ({ item }: { item: CommentsItem }) => {
        const isLIked = item.like > "0"
        return (
            <div className="d-flex align-items-start gap-3 mb-4">
                <img
                    src={item.profile && url ? url + item.profile : '/media/avatars/blank.png'}
                    alt={item.fullName}
                    className="post-modal-avatar"
                    loading="lazy"
                    decoding="async"
                />

                <div className="flex-grow-1 text-break">
                    {/* Header */}
                    <div className="d-flex align-items-center gap-2">
                        <span className="post-modal-username">{item.fullName}</span>
                        <span className="text-muted fs-7">
                            {moment(item.created).fromNow()}
                        </span>
                    </div>

                    {/* Comment text */}
                    <div className="post-modal-description mt-1">
                        {item.comment}
                    </div>

                </div>
                {/* Likes (no reply) */}
                <div className="d-flex align-items-center gap-1 mt-1 text-muted fs-7 cursor-pointer" title={isLIked ? "view liked user list" : "no likes yet"} onClick={() => {
                    setShowLikesModal(true)
                    setModalType("comment")
                    setSelectedCommentId(item.commentId)
                }}  >
                    <KTIcon iconName="heart" iconType={`${isLIked ? "solid" : "outline"}`} className={`fs-6 ${isLIked ? "text-danger" : ""}`} />
                    <span>{item.like || 0}</span>
                </div>
            </div>
        )
    }

    const renderCommentsSkeleton = () => {
        return (
            <>
                {[1, 2, 3, 4].map((item) => (
                    <div key={item} className="d-flex align-items-start gap-3 mb-4">
                        <Skeleton circle width={40} height={40} />

                        <div className="flex-grow-1">
                            <Skeleton width={120} height={14} className="mb-2" />
                            <Skeleton width="90%" height={14} className="mb-1" />
                            <Skeleton width="60%" height={14} />
                        </div>
                    </div>
                ))}
            </>
        )
    }




    return (
        <>

            {show && !shouldHidePostControls && createPortal(
                <>
                    <button
                        className="btn btn-sm btn-icon btn-danger post-modal-close-btn"
                        onClick={onHide}
                        aria-label="Close"
                    >
                        <KTIcon iconName='cross' className='text-white fs-1' iconType='solid' />
                    </button>

                    {/* Previous */}
                    {hasPrevious && (
                        <button
                            className="post-modal-nav-button post-modal-previous-button"
                            onClick={handlePrevious}
                            disabled={isTransitioning}
                            aria-label="Previous Post"
                        >
                            <KTIcon iconName="arrow-left" className="fs-2 text-dark" iconType="solid" />
                        </button>
                    )}

                    {/* Next */}
                    {hasNext && (
                        <button
                            className="post-modal-nav-button post-modal-next-button"
                            onClick={handleNext}
                            disabled={isTransitioning}
                            aria-label="Next Post"
                        >
                            <KTIcon iconName="arrow-right" className="fs-2 text-dark" iconType="solid" />
                        </button>
                    )}
                    <div className="post-modal-counter">
                        {currentIndex + 1} / {allPosts.length}
                    </div>,
                </>

                ,
                document.body
            )}

            <Modal
                show={show}
                onHide={() => {
                    onHide()
                    setShowLikesModal(false)
                    setShowOptionsModal(false)
                }}
                size="xl"
                centered
                dialogClassName="post-modal-dialog"
                contentClassName="post-modal-custom-content"
                backdropClassName="post-modal-backdrop-dark"
                backdrop="static"
                keyboard={true}
            >
                {/* <button
                    className="  btn btn-sm btn-icon btn-danger ms-auto post-modal-close-btn"
                    onClick={onHide}
                    aria-label="Close"
                >
                    <i className="ki-outline ki-cross fs-1 text-white"></i>
                </button> */}
                <div className={`post-modal-content ${isTransitioning ? `transitioning-${transitionDirection}` : ''}`}>
                    {/* Image Section */}
                    <div className="post-modal-image-section">
                        <Swiper {...swiperConfig} key={selectedPost?.postId} // ADD THIS - prevents Swiper from reloading when post changes
                        >

                            {selectedPost.media && selectedPost.media.length > 0 ? (
                                selectedPost.media.map((mediaItem: PostMedia, index: number) => (
                                    <SwiperSlide key={mediaItem.postmediaId}>
                                        <div className="swiper-slide-content">
                                            <img
                                                src={url && mediaItem.media ? url + mediaItem.media : ""}
                                                alt={`${selectedPost.destinationName} - ${index + 1}`}
                                                className="post-modal-image"
                                                onError={(e) => {
                                                    e.currentTarget.onerror = null
                                                    e.currentTarget.src = toAbsoluteUrl('/media/logos/mainLogo.png')
                                                }}
                                                loading="eager"
                                                decoding="async"
                                                onClick={() => {
                                                    if (!selectedPost?.media?.length) return;
                                                    NativeFancybox.show(
                                                        selectedPost.media.map((m: PostMedia) => ({
                                                            src: url + m.media,
                                                            type: 'image',
                                                        })),
                                                        {
                                                            startIndex: index,

                                                        }
                                                    );
                                                }}
                                            />
                                        </div>
                                    </SwiperSlide>
                                ))
                            ) : (
                                <SwiperSlide>
                                    <div className="swiper-slide-content">
                                        <img
                                            src={toAbsoluteUrl('/media/logos/mainLogo.png')}
                                            alt="No media"
                                            className="post-modal-image"
                                            loading="lazy"
                                            decoding="async"
                                        />
                                    </div>
                                </SwiperSlide>
                            )}
                        </Swiper>

                        {/* Custom Navigation Buttons */}
                        {selectedPost.media && selectedPost.media.length > 1 && (
                            <>
                                <button className="swiper-btn-prev-custom swiper-custom-btn">
                                    <KTIcon className='text-white fs-1' iconName='arrow-left' iconType='solid' />
                                </button>
                                <button className="swiper-btn-next-custom swiper-custom-btn">
                                    {/* <i className="ki-outline ki-arrow-right fs-2"></i> */}
                                    <KTIcon className='text-white fs-1' iconName='arrow-right' iconType='solid' />
                                </button>
                            </>
                        )}

                        {/* Custom Pagination */}
                        <div className="swiper-pagination-custom"></div>
                    </div>

                    {/* Info Section */}
                    <div className="post-modal-info-section">
                        <div className="post-modal-header">
                            <img
                                src={profileDetails?.profile && url ? url + profileDetails.profile : '/media/logos/mainLogo.png'}
                                alt="User"
                                loading="lazy"
                                decoding="async"
                                className="post-modal-avatar"
                            />
                            <div>

                                <div className="post-modal-username">
                                    {selectedPost.fullName || profileDetails?.fullName}

                                </div>

                                <div className='fw-normal text-break' >
                                    {selectedPost.address || ""}
                                </div>
                            </div>
                            <div
                                className="icon  ms-auto cursor-pointer"
                                onClick={() => {
                                    setShowOptionsModal(true)
                                }}
                                title='Post Settings'
                            >
                                <KTIcon iconName='setting-2' className='fs-1  text-dark' />
                            </div>
                        </div>

                        <div className="post-modal-body" ref={scrollContainerRef} onScroll={handleScroll}>
                            <div className="d-flex align-items-start gap-3">
                                <img
                                    src={profileDetails?.profile && url ? url + profileDetails.profile : '/media/logos/mainLogo.png'}
                                    alt="User"
                                    loading="lazy"
                                    decoding="async"
                                    className="post-modal-avatar"
                                />
                                <div>
                                    <div className="post-modal-username mb-1">
                                        {selectedPost.fullName || profileDetails?.fullName}
                                    </div>

                                    <div className="post-modal-description text-break">
                                        <strong>{selectedPost.destinationName}</strong><br />
                                        {selectedPost.caption}
                                    </div>
                                </div>
                            </div>
                            <hr />
                            {/* Comments */}
                            <div>
                                {isLoading && renderCommentsSkeleton()}

                                {!isLoading && !isEmptyArray(comments) && comments.map((item) => (
                                    <CommentItem key={item.commentId} item={item} />
                                ))}

                                {!isLoading && isEmptyArray(comments) && (
                                    <div className="text-center text-muted py-4">
                                        No comments yet
                                    </div>
                                )}

                                {/* Load more spinner */}
                                {isLoadingMore && (
                                    <div className="d-flex justify-content-center py-5">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                )}
                            </div>

                        </div>

                        <div className="post-modal-footer">
                            {/* Engagement Actions + Counts (Top Row) */}
                            <div className="d-flex align-items-center gap-5 mb-3 cursor-pointer">
                                <div className="d-flex align-items-center gap-2" onClick={() => {
                                    setShowLikesModal(true)
                                    setModalType("post")

                                }}
                                    title='View Post Likes List'
                                >
                                    <KTIcon iconName='heart' iconType={`${selectedPost.like > 0 ? "solid" : "outline"}`} className={`fs-2 ${selectedPost.like > 0 ? 'text-danger' : "text-dark"}`} />
                                    <span className="fw-bold text-dark fs-5">{selectedPost.like}</span>
                                </div>
                                <div className="d-flex align-items-center gap-2 pe-none">
                                    <KTIcon iconName='message-text-2' iconType='outline' className='text-dark fs-2' />
                                    <span className="fw-bold text-dark fs-5">{selectedPost.comment}</span>
                                </div>
                            </div>

                            {/* Date - Relative Time (Instagram Style) */}
                            <div className="text-muted fs-6">
                                {moment(selectedPost.created).fromNow()}
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>

            {showOptionsModal && (
                <Modal
                    show={showOptionsModal}
                    onHide={() => setShowOptionsModal(false)}
                    centered
                    dialogClassName="post-options-modal"
                    backdropClassName="options-modal-backdrop"
                >
                    <div className="post-options-list">
                        {/* Report Button - Different based on status */}

                        <button
                            className={clsx(
                                "post-option-item text-danger",
                                {
                                    "post-reported": selectedPost?.reported,
                                }
                            )}
                            onClick={() => {
                                if (selectedPost?.reported) {
                                    setShowOptionsModal(false);
                                    setShowReportDetailsModal(true);
                                } else {
                                    setShowReportModal(true);
                                    setShowOptionsModal(false);
                                }
                            }}
                            title={`${selectedPost?.reported ? "Already Reported Click To View Details" : "Report Post"}`}
                        >
                            {selectedPost?.reported ? t('Already Reported') : "Report"}
                        </button>


                        <button
                            className="post-option-item"
                            onClick={() => deletePost(selectedPost?.postId)}
                            title='Delete Post'
                        >
                            {t('Delete')}
                        </button>

                        {!selectedPost?.reported && (
                            <Link
                                to={getEncryptedRoute("../editpost/", { postId: selectedPost.postId, menuId: menuId })}
                                className="post-option-item text-dark"
                                title='Edit Post'
                            >
                                {t('Edit')}
                            </Link>
                        )}

                        <button
                            className="post-option-item"
                            onClick={() => setShowOptionsModal(false)}
                            title='Cancel'

                        >
                            {t('Cancel')}
                        </button>
                    </div>
                </Modal>
            )}

            {/* Report Modal */}
            {showReportModal && <Modal
                show={showReportModal}
                onHide={() => {
                    setShowReportModal(false);
                    setSelectedReportType('');
                    setReportTitle('');
                    setReportDescription('');
                }}
                centered
                dialogClassName="report-modal-dialog"
                contentClassName="report-modal-content"
            >
                <Modal.Header className="border-0 pb-0">
                    <div className="d-flex align-items-center w-100">
                        <button
                            className="btn btn-sm btn-icon btn-light me-3"
                            onClick={() => {
                                setShowReportModal(false);
                                setShowOptionsModal(true);
                            }}
                        >
                            <KTIcon iconName="arrow-left" className="fs-2" />
                        </button>
                        <div className="d-flex align-items-center">
                            <KTIcon iconName="shield-cross" className="fs-1 text-danger me-2" />
                            <h3 className="mb-0">{t('Report Post')}</h3>
                        </div>
                        <button
                            className="btn btn-sm btn-icon btn-light ms-auto"
                            onClick={() => setShowReportModal(false)}
                        >
                            <KTIcon iconName="cross" className="fs-2" />
                        </button>
                    </div>
                </Modal.Header>

                <Modal.Body className="pt-5">
                    <p className="text-muted mb-5">
                        {t('Please select a reason and provide details about why you\'re reporting this post.')}
                    </p>

                    {/* Report Type Options */}
                    <div className="report-options-list">
                        {/* False Information Option */}
                        <div className="report-option-card mb-3">
                            <div
                                className={`report-option-header ${selectedReportType === 'false_information' ? 'active' : ''}`}
                                onClick={() => {
                                    if (selectedReportType === 'false_information') {
                                        setSelectedReportType('');
                                        setReportDescription('');
                                    } else {
                                        setSelectedReportType('false_information');
                                        setReportTitle('');
                                        setReportDescription('');
                                    }
                                }}
                            >
                                <div className="d-flex align-items-center">
                                    <KTIcon iconName="information" className="fs-2 text-warning me-3" />
                                    <span className="fw-bold">{t('False Information')}</span>
                                </div>
                                <KTIcon
                                    iconName={selectedReportType === 'false_information' ? 'up' : 'down'}
                                    className="fs-3"
                                />
                            </div>

                            {selectedReportType === 'false_information' && (
                                <div className="report-option-content">
                                    <label className="form-label required">
                                        {t('Please provide details about the false information')}
                                    </label>
                                    <textarea
                                        className="form-control form-control-solid"
                                        rows={4}
                                        placeholder={t('Describe what information is false and why...')}
                                        value={reportDescription}
                                        onChange={(e) => setReportDescription(e.target.value)}
                                    />
                                </div>
                            )}
                        </div>

                        {/* Spam Option */}
                        <div className="report-option-card mb-3">
                            <div
                                className={`report-option-header ${selectedReportType === 'spam' ? 'active' : ''}`}
                                onClick={() => {
                                    if (selectedReportType === 'spam') {
                                        setSelectedReportType('');
                                        setReportDescription('');
                                    } else {
                                        setSelectedReportType('spam');
                                        setReportTitle('');
                                        setReportDescription('');
                                    }
                                }}
                            >
                                <div className="d-flex align-items-center">
                                    <KTIcon iconName="flag" className="fs-2 text-danger me-3" />
                                    <span className="fw-bold">{t('Spam')}</span>
                                </div>
                                <KTIcon
                                    iconName={selectedReportType === 'spam' ? 'up' : 'down'}
                                    className="fs-3"
                                />
                            </div>

                            {selectedReportType === 'spam' && (
                                <div className="report-option-content">
                                    <label className="form-label required">
                                        {t('Please provide details about the spam content')}
                                    </label>
                                    <textarea
                                        className="form-control form-control-solid"
                                        rows={4}
                                        placeholder={t('Describe why this is spam...')}
                                        value={reportDescription}
                                        onChange={(e) => setReportDescription(e.target.value)}
                                    />
                                </div>
                            )}
                        </div>

                        {/* Other Option */}
                        <div className="report-option-card mb-3">
                            <div
                                className={`report-option-header ${selectedReportType === 'other' ? 'active' : ''}`}
                                onClick={() => {
                                    if (selectedReportType === 'other') {
                                        setSelectedReportType('');
                                        setReportTitle('');
                                        setReportDescription('');
                                    } else {
                                        setSelectedReportType('other');
                                        setReportDescription('');
                                    }
                                }}
                            >
                                <div className="d-flex align-items-center">
                                    <KTIcon iconName="menu" className="fs-2 text-primary me-3" />
                                    <span className="fw-bold">{t('Other')}</span>
                                </div>
                                <KTIcon
                                    iconName={selectedReportType === 'other' ? 'up' : 'down'}
                                    className="fs-3"
                                />
                            </div>

                            {selectedReportType === 'other' && (
                                <div className="report-option-content">
                                    <div className="mb-4">
                                        <label className="form-label required">{t('Report Title')}</label>
                                        <input
                                            type="text"
                                            className="form-control form-control-solid"
                                            placeholder={t('Enter report title...')}
                                            value={reportTitle}
                                            onChange={(e) => setReportTitle(e.target.value)}
                                        />
                                    </div>
                                    <div>
                                        <label className="form-label required">{t('Description')}</label>
                                        <textarea
                                            className="form-control form-control-solid"
                                            rows={4}
                                            placeholder={t('Describe the issue...')}
                                            value={reportDescription}
                                            onChange={(e) => setReportDescription(e.target.value)}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer className="border-0">
                    <button
                        className="btn btn-light w-100 mb-2"
                        onClick={() => {
                            setShowReportModal(false);
                            setSelectedReportType('');
                            setReportTitle('');
                            setReportDescription('');
                        }}
                    >
                        {t('Cancel')}
                    </button>
                    <button
                        className="btn btn-danger w-100"
                        onClick={submitReport}
                        disabled={!selectedReportType || isLoading}
                    >
                        {isLoading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2"></span>
                                {t('Submitting...')}
                            </>
                        ) : (
                            t('Submit Report')
                        )}
                    </button>
                </Modal.Footer>
            </Modal>}

            {showLikesModal &&
                <>
                    <LikesModal

                        show={showLikesModal}
                        onHide={() => {
                            setShowLikesModal(false)
                            setSelectedCommentId(0)
                        }}
                        type={modalType}
                        referenceId={modalType == "post" ? selectedPost?.postId : selectedCommentId}
                        baseUrl={url}
                    />


                </>
            }

            {/* Report Details Modal - Shows existing report info */}
            {showReportDetailsModal && selectedPost?.reported && (
                <Modal
                    show={showReportDetailsModal}
                    onHide={() => setShowReportDetailsModal(false)}
                    centered
                    dialogClassName="report-modal-dialog"
                    contentClassName="report-modal-content"
                >
                    <Modal.Header className="border-0 pb-0">
                        <div className="d-flex align-items-center w-100">
                            <button
                                className="btn btn-sm btn-icon btn-light me-3"
                                onClick={() => {
                                    setShowReportDetailsModal(false);
                                    setShowOptionsModal(true);
                                }}
                            >
                                <KTIcon iconName="arrow-left" className="fs-2" />
                            </button>
                            <div className="d-flex align-items-center">
                                <KTIcon iconName="shield-tick" className="fs-1 text-success me-2" />
                                <h3 className="mb-0">{t('Report Details')}</h3>
                            </div>
                            <button
                                className="btn btn-sm btn-icon btn-light ms-auto"
                                onClick={() => setShowReportDetailsModal(false)}
                            >
                                <KTIcon iconName="cross" className="fs-2" />
                            </button>
                        </div>
                    </Modal.Header>

                    <Modal.Body className="pt-5">
                        <div className="alert alert-success d-flex align-items-center mb-5">
                            <KTIcon iconName="information-5" className="fs-2 me-3" />
                            <div>
                                <div className="fw-bold">{t('This post has been reported')}</div>
                                <small className="text-muted">
                                    {selectedPost.reportedAt
                                        ? `${t('Reported on')} ${moment(selectedPost.reportedAt).format('MMMM DD, YYYY [at] HH:mm')}`
                                        : ''}
                                </small>
                            </div>
                        </div>

                        <div className="report-details-content">
                            <div className="mb-5">
                                <label className="form-label fw-bold text-dark">
                                    {t('Violation Type')}
                                </label>
                                <div className="p-4 bg-light rounded">
                                    <div className="d-flex align-items-center">
                                        <KTIcon
                                            iconName={
                                                selectedPost.violation === 'spam' ? 'flag' :
                                                    selectedPost.violation === 'false_information' ? 'information' :
                                                        'menu'
                                            }
                                            className={`fs-2 me-3 ${selectedPost.violation === 'spam' ? 'text-danger' :
                                                selectedPost.violation === 'false_information' ? 'text-warning' :
                                                    'text-primary'
                                                }`}
                                        />
                                        <span className="fw-bold">
                                            {selectedPost.violation === 'spam'
                                                ? t('Spam')
                                                : selectedPost.violation === 'false_information'
                                                    ? t('False Information')
                                                    : selectedPost.violation || t('Other')}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="mb-5">
                                <label className="form-label fw-bold text-dark">
                                    {t('Report Reason')}
                                </label>
                                <div className="p-4 bg-light rounded">
                                    <p className="mb-0 text-gray-700">
                                        {selectedPost.reason || t('No reason provided')}
                                    </p>
                                </div>
                            </div>

                            <div className="d-flex gap-3">
                                <Link
                                    to={getEncryptedRoute("../editpost/", { postId: selectedPost.postId, menuId: menuId })}
                                    className="btn btn-primary flex-grow-1"
                                >
                                    <KTIcon iconName="notepad-edit" className="fs-3 me-2" />
                                    {t('Edit Post')}
                                </Link>
                                <button
                                    className="btn btn-light-danger flex-grow-1"
                                    onClick={() => {
                                        setShowReportDetailsModal(false);
                                        deletePost(selectedPost?.postId);
                                    }}
                                >
                                    <KTIcon iconName="trash" className="fs-3 me-2" />
                                    {t('Delete Post')}
                                </button>
                            </div>
                        </div>
                    </Modal.Body>

                    <Modal.Footer className="border-0">
                        <button
                            className="btn btn-light w-100"
                            onClick={() => setShowReportDetailsModal(false)}
                        >
                            {t('Close')}
                        </button>
                    </Modal.Footer>
                </Modal>
            )}
        </>
    );
}